<template>
	<div class="offer-instructions">
		<div class="offer-instructions__title">Instructions</div>
		<div class="offer-instructions__description">{{ parsedInstructions[0] }}</div>
		<v-list class="offer-instructions__list">
			<v-list-item v-for="(item, index) in parsedInstructions.slice(1)" :key="index">
				<template v-slot:prepend>
					<v-icon><list-bullet /></v-icon>
				</template>
				<v-list-item-title class="text-wrap offer-instructions__description">{{ item }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ListBullet from '@/icons/ListBullet.vue';

const props = defineProps({
	instructions: {
		type: String,
		required: true
	}
});

const parsedInstructions = computed(() => {
	return props.instructions.split('\n').map(instruction => instruction.replace(/<[^>]*>?/gm, ''));
});

</script>



<style scoped lang="scss">

.offer-instructions {
	display: flex;
	flex-direction: column;
	gap: 16px;

	&__title {
		font-weight: 700;
		font-size: 22px;
	}
	
	&__description {
		font-weight: 500;
		font-size: 16px;
		color: vars.get-map-value(vars.$text-color, subtitle);
	}
	
	&__list {
		background-color: transparent;
	}
}

</style>
